import ExecutionReportingService from 'services/ExecutionReportingService';

class ExecutionReportingAdapter extends ExecutionReportingService {

  createReport(report) {
    return {
      id: report.ReportID,
      name: report.ReportName,
      path: report.ReportPath
    };
  }

  createPublisher(publisher) {
    return {
      id: publisher.publisherID,
      name: publisher.publisherName,
      type: publisher.publisherType,
      mtc: publisher.publisherMIC,
      reports: publisher.dates.map((reportDate, index) => ({
        id: index,
        date: reportDate.date,
        name: reportDate.text
      }))
    };
  }

  loadPublishers() {
    return this.getPublishers()
       .then((result) => {
         return result.map(this.createPublisher);
       });
  }

  loadReports(params) {
    return this.getReports(params)
       .then((result) => {
         return result.map((item, index) => ({
           id: index,
           name: item.SegmentMIC,
           description: item.SegmentMICDescription,
           reports: item.Reports.map(this.createReport)
         }));
       });
  }
}

const instance = new ExecutionReportingAdapter();

export default instance;


// WEBPACK FOOTER //
// ./src/adapters/ExecutionReportingAdapter.js